import { ChangeDetectionStrategy, Component, input, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { NgStyle } from '@angular/common';

import { MultiSelectSearchComponent, OutputFormat } from '@hglobal/common';
import { TranslateModule } from '@ngx-translate/core';
import { SlackChannel } from '@pt/models';

import { SLACK_CHANNEL_WORKSPACE_COLORS, SlackChannelWorkspace } from '../../constants/slack-channel';

@Component({
  selector: 'pt-slack-channel-dropdown',
  imports: [
    MultiSelectSearchComponent,
    ReactiveFormsModule,
    TranslateModule,
    NgStyle,
  ],
  templateUrl: './slack-channel-dropdown-component.html',
  styleUrls: ['./slack-channel-dropdown-component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SlackChannelItemComponent {
  channels = input<SlackChannel[]>([]);
  controlId = input<string>('');
  control = input.required<FormControl>();
  label = input<string>('admin.newsForm.control.channels');
  outputFormat = input<OutputFormat>(OutputFormat.Primitive);

  slackChannelWorkspaceColors = SLACK_CHANNEL_WORKSPACE_COLORS;

  getWorkspaceColor(workspace: SlackChannelWorkspace): string {
    const color = this.slackChannelWorkspaceColors[workspace];
    return color ? `var(${color})` : 'transparent';
  }
}
